module.exports = "https://cdn.thelire.com/ins/resource/pic_pop_sorry@3x.92cdf1e45b3ddb77e02fa806ffea90d1.png";